import * as types from '../types'

const state = () => ({
  isLoggedIn: false,
  user: {
    email: '',
    token: ''
  },
  token: "",
})

const getters = {
  [types.BACKOFFICE_IS_LOGGED_IN]: (state) => {
    return state.isLoggedIn
  },
  [types.BACKOFFICE_USER]: (state) => {
    return state.user
  },
  [types.BACKOFFICE_TOKEN]: (state) => {
    return state.token
  },
}

const mutations = {
  [types.BACKOFFICE_MUTATE_LOGIN]: (state, payload) => {
    state.isLoggedIn = true
    state.user = payload.user
    state.token = payload.token
  },
  [types.BACKOFFICE_MUTATE_LOGOUT]: (state) => {
    state.isLoggedIn = false
    state.user = null
    state.token = ""
  },
}

const actions = {
  [types.BACKOFFICE_LOGIN]: ({ commit }, payload) => {
    commit(types.BACKOFFICE_MUTATE_LOGIN, payload)
  },
  [types.BACKOFFICE_LOGOUT]: ({ commit }) => {
    commit(types.BACKOFFICE_MUTATE_LOGOUT)
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex-store/backoffice/auth.js